import React from "react";
import "./style.css";
import "../home/style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";
import { meta } from "../../content_option";
import { jobsFotos } from "../../utils/jobs";
import { useNavigate } from "react-router-dom";

export const Portfolio = () => {
  const navigate = useNavigate();

  const onClickHandler = (data) => {
    navigate(`/proyectos`, { state: { project: data } });
  };

  const onClickHandlerToClose = () => {
    navigate(`/`);
  };

  return (
    <HelmetProvider>
      <Container className="About-header">
        <Helmet>
          <meta charSet="utf-8" />
          <title> Portfolio | {meta.title} </title>{" "}
          <meta name="description" content={meta.description} />
        </Helmet>
        <Row className="mb-5 mt-3 pt-md-3">
          <Col lg="8">
            <div className="d-flex justify-content-between align-items-baseline">
              <h1 className="display-4 mb-4 ac_btn btn_modal ac_title">
                {" "}
                Portfolio{" "}
              </h1>{" "}
              <button
                className="back_btn font-italic font-weight-bold btn ac_btn btn_modal"
                onClick={() => onClickHandlerToClose()}
              >
                volver
              </button>
            </div>
            <hr className="t_border my-4 ml-0 text-left" />
          </Col>
        </Row>
        <div className="mb-5 po_items_ho">
          {jobsFotos.map((data, i) => {
            return (
              <div key={i} className="po_item">
                <h1 className="po_item_h1">{data.description}</h1>
                <img src={data.src} alt={data.alt} />
                <div className="content">
                  <button
                    className="btn ac_btn btn_modal"
                    onClick={(event) => onClickHandler(data.title, event)}
                  >
                    ver album
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </Container>
    </HelmetProvider>
  );
};
